<template>
  <div class="page">
    <div class="banner">
      <div class="container d-flex justify-content-center">
        <h1 class="card-title mb-3 text-dark text-uppercase" style="font-weight:700;"><span
            style="color: #ffffff">{{userData.customerName}}</span></h1>
      </div>
      <div class="container d-flex justify-content-center">
        <img style="height: 120px; width: 120px;" :src="image || require('@/assets/no_image_picture.png')" alt="logo">
      </div>
    </div>
    <div class="container d-flex justify-content-center">
    </div>
    <KazGateWay />
    <FloatingActionButton @click="logout" icon="lock" />
  </div>
</template>

<script>
import KazGateWay from "@/components/KazGateWay.vue";
import FloatingActionButton from "@/components/FloatingActionButton.vue";

export default {
  name: "PosLoginView",
  components: {FloatingActionButton, KazGateWay},
  beforeMount() {
    this.getDocumentUrl();
  },
  computed:{
    userData(){
      return this.$store.getters.getuserData;
    }
  },
  data(){
    return {
      image: '',
    }
  },
  methods:{
    stripMimeType(base64) {
      const pattern = /^data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+);base64,/;
      base64 = base64.replace(pattern, "");
      const binary = atob(base64); // Decode the base64 string
      const array = [];
      for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      return new Uint8Array(array);
    },
    getDocumentUrl() {
      const logo = this.userData.logo;
      console.log(logo);
      let data = this.stripMimeType(logo);
      const blob = new Blob([data], { type: logo.type });
      return this.image = URL.createObjectURL(blob);
    },
    logout(){
      this.$store.dispatch("logout");
      return this.$router.push({name: 'login'})
    }
  }
}
</script>

<style scoped>
.page {
  background: rgb(64, 67, 74);
  background: -moz-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: -webkit-linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  background: linear-gradient(180deg, rgba(64, 67, 74, 1) 14%, rgba(255, 255, 255, 1) 14%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#40434a", endColorstr="#ffffff", GradientType=1);
}
.banner {
  height: 30vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  background: #40434A;
  margin-top: -2px !important;
  max-height: 280px;
}
</style>